import { render, staticRenderFns } from "./LoginFormDefault.vue?vue&type=template&id=fccb1346&scoped=true&"
import script from "./LoginFormDefault.vue?vue&type=script&lang=js&"
export * from "./LoginFormDefault.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fccb1346",
  null
  
)

export default component.exports